import { Box, Typography, Button } from '@mui/material';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as SuccessIcon } from 'src/assets/svg/success-green-circle.svg';
import { appConfig } from 'src/app';

import { styles } from './styles';

export const SuccessPage: FC = () => {
    const { t } = useTranslation();
    const accountPage = appConfig.myAccountUrl;

    useEffect(() => {
        window.dataLayer.push({
            event: 'complete_booking',
        });
    });

    return (
        <Box css={styles.container}>
            <Box css={styles.imageContainer} />

            <Box css={styles.wrapper}>
                <SuccessIcon />

                <Typography variant="h1">{t('success_title')}</Typography>

                <Typography
                    variant="body3"
                    dangerouslySetInnerHTML={{ __html: t('success_content') }}
                />

                <Button variant="contained" css={styles.cta} href={accountPage}>
                    {t('success_btn')}
                </Button>
            </Box>
        </Box>
    );
};
